import React, { Component } from "react";
import { Card, Row, Col } from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getDataAtual, formataDataHoraExibicao } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import logomarca from '../../assets/images/logo_cuidados_branco.png';
import logomarca2 from '../../assets/images/logo_ache_branco.png';

class OptOut extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            atendimento_uuid: "",
            optout_data: null,
            optout_motivo_id: null,
            optout_motivo_outros: null,
            motivos_optout: [],
            titulo_pagina: "OptOut do Programa",
            motivo_id: "",
            motivo_outros: "",
            mostrarCampoOutro: false,
            loading: false,
            erroLoadRegistro: "",
            programa: {}
        };
    }

    componentDidMount(){
        const uuid = this.props.router.params.id;
        const searchParams = new URLSearchParams(this.props.router.location.search);

        if(uuid){
            this.setState({
                atendimento_uuid: uuid,
                loading: true,
                erroLoadRegistro: ''
            })

            let config = {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }

            //consulta os dados do programa na api
            api.get(`/atendimentos/programas-optout/${uuid}/`, config)
            .then((response) => {
                const dados = response.data;

                // Atualiza o estado com os dados recebidos
                this.setState({
                    loading: false,
                    erroLoadRegistro: "",
                    programa: dados.programa,
                    optout_data: dados.optout_data,
                    optout_motivo_id: dados.optout_motivo_id,
                    optout_motivo_outros: dados.optout_motivo_outros,
                    motivos_optout: dados.motivos_optout,
                }, () => {
                    if (dados.programa.layout_cor_fundo) {
                        const rootBefore = document.createElement("style");
                        rootBefore.innerHTML = `
                            #root::before {
                                background: ${dados.programa.layout_cor_fundo};
                            }
                        `;
                        document.head.appendChild(rootBefore);
                    }
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar OptOut, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    loading: false,
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    enviarMotivo = () => {
        const { motivo_id, motivo_outros, atendimento_uuid } = this.state;
    
        if (!atendimento_uuid) {
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Identificador do atendimento não encontrado. Por favor, recarregue a página.',
            });
            return;
        }
    
        // Exibir o SweetAlert de confirmação
        Swal.fire({
            title: 'Tem certeza?',
            text: "Deseja encerrar sua participação no programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, encerrar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                // Condiciona o envio do motivo_id dependendo da seleção
                const payload = {
                    ...(motivo_id !== 'Outro' && { motivo_id: parseInt(motivo_id, 10) }), // Envia motivo_id apenas se não for "Outro"
                    motivo_outros: motivo_id === 'Outro' ? motivo_outros : null, // Envia motivo_outros apenas se motivo_id for "Outro"
                };

                if(this.state.programa.optout_status_id) {
                    payload['programa_status_id'] = this.state.programa.optout_status_id;
                }
    
                let config = {
                    headers: {
                        'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                    }
                };
    
                api.put(`/atendimentos/programas-optout/${atendimento_uuid}/`, payload, config)
                    .then((response) => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Sucesso',
                            text: 'Sua participação no programa foi encerrada com sucesso!',
                        }).then(() => {
                            window.location.reload();
                        });
                    })
                    .catch((error) => {
                        let erro_msg = 'Erro ao tentar encerrar a participação no programa. Tente novamente.';
    
                        if (error.response) {
                            if (error.response.status === 500) {
                                erro_msg = 'Servidor indisponível no momento, tente novamente.';
                            } else if (error.response.data && error.response.data.message) {
                                erro_msg = error.response.data.message;
                            }
                        }
    
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: erro_msg,
                        });
                        console.error('Erro na requisição:', error);
                    });
            }
        });
    };
    
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    render(){
        if(this.state.loading) {
            return(
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={8}>
                            <h1 className="page-title title-optout text-center mb-5">Carregando OptOut</h1>
                        </Col>
                    </Row>
                </div>
            )
        }        
        return (
            <div className="container">
                <Row className="mt-2 align-items-center justify-content-center">
                    <Col sm={8} lg={8}>
                        <Row className="align-items-center mt-0 mb-5">
                            <Col sm={2}>
                                {this.state.programa.optout_logomarca_1 ? (
                                    <div className="text-center">
                                        <img src={this.state.programa.optout_logomarca_1} alt={this.state.programa.nome} className="img-fluid" />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <img src={logomarca} alt={this.state.programa.nome} className="img-fluid"  style={{maxHeight: "30px"}} />
                                    </div>
                                )}
                            </Col> 
                            <Col sm={8}>
                                <h1 className="page-title title-optout text-center mb-3 mt-3">Encerramento de Participação no<br />{this.state.programa.optout_titulo}</h1>      
                            </Col> 
                            <Col sm={2}>
                                {this.state.programa.optout_logomarca_2 ? (
                                    <div className="text-center">
                                        <img src={this.state.programa.optout_logomarca_2} alt={this.state.programa.nome} className="img-fluid" />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <img src={logomarca2} alt={this.state.programa.nome} className="img-fluid" style={{maxHeight: "30px"}} />
                                    </div>
                                )}
                            </Col>                            
                        </Row>

                        <Card className="cardDestaque">     
                            {this.state.optout_data ? (
                                <Card.Body className="p-4">
                                    <div className="mb-4 mt-3">
                                        <p>
                                        Você já optou pelo encerramento de sua participação do programa em <strong>{formataDataHoraExibicao(this.state.optout_data)}</strong>
                                        </p>
                                        <p>
                                            Motivo:{" "}
                                            <strong>
                                            {this.state.optout_motivo_id
                                                ? this.state.motivos_optout.find(motivo => motivo.id === this.state.optout_motivo_id)?.titulo || "Motivo não encontrado"
                                                : this.state.optout_motivo_outros}
                                            </strong>
                                        </p>
                                    </div>
                                </Card.Body>
                            ) : (                       
                                <Card.Body className="p-4">
                                    <div className="mb-4">
                                        <p>
                                        ☹️ Poxa, que pena que você não continuará com a gente, sentiremos sua falta. 
                                        <br /><br />
                                        Por favor, nos conte o motivo da sua saída para que possamos aprimorar o nosso atendimento.
                                        </p>
                                        <div className="form-group">
                                            <select
                                                id="motivoSaida"
                                                className="form-control"
                                                value={this.state.motivo_id}
                                                onChange={(e) =>
                                                    this.setState({
                                                        motivo_id: e.target.value,
                                                        mostrarCampoOutro: e.target.value === "Outro",
                                                    })
                                                }
                                            >
                                                <option value="">Selecione um motivo</option>
                                                {this.state.motivos_optout.map((motivo) => (
                                                    <option key={motivo.id} value={motivo.id}>
                                                        {motivo.titulo}
                                                    </option>
                                                ))}
                                                <option value="Outro">Outro</option>
                                            </select>
                                        </div>
                                        {this.state.mostrarCampoOutro && (
                                            <div className="form-group mt-3">
                                                <label htmlFor="motivo_outros">Especifique o motivo:</label>
                                                <textarea
                                                    id="motivo_outros"
                                                    className="form-control"
                                                    rows="3"
                                                    value={this.state.motivo_outros}
                                                    onChange={(e) => this.setState({ motivo_outros: e.target.value })}
                                                ></textarea>
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-center">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => this.enviarMotivo()}
                                            disabled={!this.state.motivo_id || (this.state.motivo_id === "Outro" && !this.state.motivo_outros)}
                                            style={{
                                                backgroundColor: this.state.programa.layout_cor_primaria || "#007bff",
                                                borderColor: this.state.programa.layout_cor_primaria || "#007bff",
                                            }}
                                        >
                                            Enviar
                                        </button>
                                    </div>
                                </Card.Body>
                            )}
                        </Card>

                        {this.state.programa_imagem_branca && (
                            <div className="mt-5 text-center">
                                <p>Powered by <a href="https://aditushealth.com.br" target="_blank"><img src={logomarca} alt="Aditus Health" style={{ maxWidth: '60px' }} /></a></p>
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouter(OptOut);